module.exports = __webpack_public_path__ + "img/2B2828_7B796F_534F4A_616464-256px.73f03606.png";